import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import Login from "./components/Login/adminLogin.jsx";
import Header from "./components/Header/index.jsx";
import Userside from './components/Userside/index.jsx'

import Userhome from './components/UserDashboard/userContent/userHome.jsx'
import UserHeader from './components/Userheader/index.jsx'

// Import the Dashboard component and related routes
import Dashboard from "./components/AdminDashboard/Dashboard";
import ViewCompany from "./components/AdminDashboard/contentComponents/viewCompany";
import AddCompany from './components/AdminDashboard/contentComponents/addCompany.jsx'
import ShowUser from "./components/AdminDashboard/contentComponents/showUser";
import CompanyAssessment from "./components/AdminDashboard/contentComponents/companyAssesment";
import AllAssessments from "./components/AdminDashboard/contentComponents/allAssesments.jsx";
import AssessmentDashboard from "./components/AdminDashboard/contentComponents/assessmentDashboard.jsx";

import HomePage from "./components/AdminDashboard/contentComponents/HomePage.jsx";
import CompanyLogin from "./components/Login/companyLogin.jsx";

import UserLogin from "./components/Login/userLogin.jsx";
import UserDashboard from "./components/UserDashboard/UserDashboard.jsx";

import Changepassword from "./components/Userside/Changepasswod";
import Showassessment from "./components/Userside/Showassessment";
import Userassessments from "./components/Userside/Assessments";
import Listassessment from "./components/Userside/Listassessment";
import Listmail from "./components/Userside/Listmail";
import UserD from "./components/Userside/UserD";
import UserRegister from "./components/Userside/UserRegister";
import EditPage from "./components/Userside/UserD/Edit";
import Userassessment from "./components/Userside/Assessment";

import AddUser from "./components/AdminDashboard/contentComponents/addUser.jsx";
import AddCompanyByEmail from './components/AdminDashboard/contentComponents/addCompanyByEmail.jsx';
import AddAssessmentType from './components/AdminDashboard/contentComponents/addAssessmentType.jsx';
import AssignAssesment from './components/AdminDashboard/contentComponents/AssignAssesment.jsx';
import ViewAllUsers from './components/AdminDashboard/contentComponents/ViewAllUsers.jsx';
import CreateAssessment from './components/AdminDashboard/contentComponents/CreateAssesment.jsx'; 
import CompanyDashboard from "./components/CompanyDashboard/CompanyDashboard.jsx";
import TakeAssessmentPage from "./components/UserDashboard/userContent/TakeAssessment.jsx";
import ViewEditUser from "./components/UserDashboard/userContent/ViewEditUser.jsx";
import CompanyPage from "./components/AdminDashboard/contentComponents/CompanyPage.jsx";
import EditCompanyPage from "./components/AdminDashboard/contentComponents/EditCompanyPage.jsx";
import CompanyViewCompany from "./components/CompanyDashboard/CompanyContent/CompanyviewCompany.jsx";
import CompanyCompanyPage from "./components/CompanyDashboard/CompanyContent/CompanyCompanyPage.jsx";
import CompanyCompanyAssessment from "./components/CompanyDashboard/CompanyContent/CompanyCompanyAssessment.jsx";
import CompanyAssessmentTable from "./components/CompanyDashboard/CompanyContent/CompanyallAssesments.jsx";
import CompanyEditCompanyPage from "./components/CompanyDashboard/CompanyContent/CompanyEditCompanyPage.jsx";
import ChangeEmailPage from "./components/AdminDashboard/contentComponents/ChangeEmailBody.jsx";
import SearchAssessmentByUser from "./components/AdminDashboard/contentComponents/SearchAssessmentByUser.jsx";
import ViewDepartment from "./components/AdminDashboard/contentComponents/ViewDepartment.jsx";
import ReviewByCompany from "./components/AdminDashboard/contentComponents/ReviewByCompany.jsx";
import ReviewByDepartment from "./components/AdminDashboard/contentComponents/ReviewByDepartment.jsx";
import ViewScore from "./components/AdminDashboard/contentComponents/ViewScore.jsx";
import ManuallyAddSubscription from "./components/AdminDashboard/contentComponents/ManuallyAddSubscription.jsx";
import SubscriptionStatus from "./components/AdminDashboard/contentComponents/SubscriptionStatus.jsx";
import CompanyViewDepartment from "./components/CompanyDashboard/CompanyContent/CompanyViewDepartment.jsx";
import CompanyAssignAssesment from "./components/CompanyDashboard/CompanyContent/CompanyAssignAssesment.jsx";
import CompanyAddCompany from "./components/CompanyDashboard/CompanyContent/CompanyAddCompany.jsx";
import ManageDepartment from "./components/AdminDashboard/contentComponents/ManageDepartment.jsx";
import EditDepartment from "./components/AdminDashboard/contentComponents/EditDepartment.jsx";
import CSVViewer from "./components/AdminDashboard/contentComponents/CSVViewer.jsx";
import CompanyEditDepartment from "./components/CompanyDashboard/CompanyContent/CompanyEditDepartment.jsx";
import AssessmentStatus from "./components/AdminDashboard/contentComponents/AssessmentStatus.jsx";
import CompanyAssessmentStatus from "./components/CompanyDashboard/CompanyContent/CompanyAssessmentStatus.jsx";
import AssessmentStatusCertificate from "./components/AdminDashboard/contentComponents/AssessmentStatusCertificate.jsx";
import UserAssessmentsCertificate from "./components/AdminDashboard/contentComponents/UserAssessmentsCertificate.jsx";
import ViewCertificate from "./components/UserDashboard/ViewCertificate.jsx";
import CompanyAssessmentDashboard from "./components/CompanyDashboard/CompanyContent/CompanyAssessmentDashboad.jsx";


const Routing = () => {
  const user = localStorage.getItem("token");
  const user1 = localStorage.getItem("token1");

  return (
    <Routes>
      { <Route path="/" exact element={<HomePage />} />}
      <Route path="/admin-login" exact element={<Login />} />
      <Route path="/company-register" exact element={<CompanyAddCompany />} />
      <Route path="/user-register" exact element={<AddUser />} />
      
      <Route path="/company-login" exact element={<CompanyLogin />} />
      <Route path="/user-login" exact element={<UserLogin />} />
      <Route path="/company-login" exact element={<CompanyLogin />} />

      {/* Admin Routes */}
      { user && 
      <Route path="/admin" element={<Dashboard />}>
          {/* Default content if you go to /admin */}
          <Route index element={<ViewDepartment />} />

          {/* The rest of your routes after /admin/... */}
          
          <Route path="manage-department" element={<ManageDepartment/>} />
          <Route path="assessment-questions" element={<CSVViewer/>} />
          <Route path="manage-department/:admincode" element={<EditDepartment/>} />
          <Route path="change-emailBody" element={<ChangeEmailPage/>} />
          <Route path="view-department" element={<ViewDepartment/>} />
          <Route path="add-company" element={<AddCompany/>} />
          <Route path="add-company-by-email" element={<AddCompanyByEmail />} />
          <Route path="company-assessment" element={<CompanyAssessment />} />
          <Route path="view-company" element={<ViewCompany />} />
          <Route path="view-company/:id" element={<CompanyPage />} />
          <Route path="view-company/:id/company-assessment/:deptid" element={<CompanyAssessment />} />
          <Route path="view-company/edit/:companycode" element={<EditCompanyPage />} />
          <Route path="add-assessment-type" element={<AddAssessmentType />} />
          {/* <Route path="assign-assessment" element={<AssignAssesment />} /> */}
          <Route path="view-all-users" element={<ViewAllUsers />} />
          <Route path="search-assessments" element={<SearchAssessmentByUser />} />
          <Route path="search-assessments/:assessmentId" element={<Showassessment />} />
          <Route path="review-company" element={<ReviewByCompany />} />
          <Route path="review-department" element={<ReviewByDepartment />} />
          <Route path="view-score" element={<ViewScore/>} />
          <Route path="manual-subscription" element={<ManuallyAddSubscription/>} />
          <Route path="subscription-status" element={<SubscriptionStatus/>} />
          <Route path="assessment-status" element={<AssessmentStatus/>} />
          {/* <Route path="assessment/certificate/:admincode/:id" element={<AssessmentStatusCertificate />} /> */}
          

          <Route path="assessment-dashboard" element={<AssessmentDashboard />} />
          <Route path="all-assessments" element={<AllAssessments />} />
          <Route path="all-assessments/:assessmentId" element={<Showassessment />} />
          <Route path="create-assessment" element={<CreateAssessment />} />
          {/* Add more as needed */}

        </Route>}
       2
    {/* Company routes */}
        { user && 
      <Route path="/company" element={<CompanyDashboard />}>
          {/* Default content if you go to /admin */}
          <Route index element={<CompanyViewDepartment />} />

          {/* The rest of your routes after /admin/... */}
          {/* <Route path="add-company" element={<AddCompany/>} /> */}
          {/* <Route path="add-company-by-email" element={<AddCompanyByEmail />} /> */}
          <Route path="assessment-dashboard" element={<CompanyAssessmentDashboard />} />
          <Route path="company-assesment" element={<CompanyAssessment />} />
          <Route path="edit-company" element={<CompanyViewCompany />} />
          <Route path="view-company" element={<CompanyViewDepartment />} />
          <Route path="view-company/:id" element={<CompanyCompanyPage/>} />
          <Route path="view-company/:id/:admincode" element={<CompanyEditDepartment/>} />
          <Route path="assessment-status" element={<CompanyAssessmentStatus/>} />
          <Route path="view-company/:id/company-assessment/:deptid" element={<CompanyCompanyAssessment/>} />
          <Route path="view-company/edit/:companycode" element={<CompanyEditCompanyPage />} />
          {/* <Route path="add-assessment-type" element={<AddAssessmentType />} /> */}
          {/* <Route path="assign-assessment" element={<AssignAssesment />} /> */}
          <Route path="view-all-users" element={<ViewAllUsers />} />
          <Route path="all-assessments" element={<CompanyAssessmentTable />} />
          <Route path="assign-assessments" element={<CompanyAssignAssesment />} />
          <Route path="all-assessments/:assessmentId" element={<CompanyAssessmentTable />} />
          <Route path="subscription-status" element={<SubscriptionStatus/>} />
          {/* <Route path="create-assessment" element={<CreateAssessment />} /> */}
          {/* Add more as needed */}

        </Route>}

         {/* USER DASHBOARD PARENT ROUTE */}
      {user1  && <Route path="/user" element={<UserDashboard />}>
          {/* If you visit /user exactly, show TakeAssessmentPage by default */}
          <Route index element={<TakeAssessmentPage />} />

          {/* Child routes for the sections in the sidebar */}
          <Route path="view-user-profile" element={<ViewEditUser />} />
          <Route path="take-assessment" element={<TakeAssessmentPage />} />
          <Route path="certificate" element={<ViewCertificate />} />
        </Route>}

        {/* ... other routes in your app, if any */}
      
        <Route path="/user-landingpage/:val" exact element={<Userside />} />
         <Route path="/certificate/:admincode/:id" exact element={<AssessmentStatusCertificate />} />
         <Route path="/certificate/:id" exact element={<UserAssessmentsCertificate />} />
        <Route path="/user-landingpage/:val/login" exact element={<Userside />} />
        <Route path="/user-landingpage/:val/register" exact element={<Userside />} />
        <Route path="/user-landingpage/" exact element={<Userside />} />
  {/* {user1 && <Route path="/user-landingpage/assessments" exact element={<Userassessments />} />}
      {user1 && <Route path="/user-landingpage/assessments" exact element={<Userassessments />} />} */}
      
     
    
      {/* <Route path="/landingpage/login" exact element={<Userlogin />} /> */}
       {/* <Route path="/landingpage/changepassword" exact element={<Changepassword />} /> */}
      <Route path="/user-landingpage/showassessment/:assessmentId" exact element={<Showassessment />} />
      <Route path="/user-landingpage/listassessment" exact element={<Listassessment />} />
      <Route path="/user-landingpage/listmail" exact element={<Listmail />} />
      <Route path="/user-landingpage/register/:val" exact element={<UserRegister />} />
      {user1 && <Route path="/user-landingpage/assessment" exact element={<Userassessment />} />}
      
      {user1 && <Route path="/user-landingpage/userdetails" exact element={<UserD />} />}
      {user && <Route path="/edit/:id" exact element={<EditPage />} />} 
      {/* user dashboard routes */}
      {/* <Route path="/" element={<Navigate replace to="/login" />} /> */}
      
      {/* {user && <Route path="/partners" exact element={<Partners />} />}
      {user && <Route path="/partners/add-partnerform" exact element={<Addpartnerform />} />}
      {user && <Route path="/partners/partnerdetails/:val" exact element={<Partnerdetails />} />}
      {user && <Route path="/partners/companydetails" exact element={<Companydetails />} />} */}
      
     
      
      {/* {user1 && <Route path="/userhome" exact element={<UserDashboard />} />} */}
      {/* Dashboard Routes */}
      {/* {user && <Route path="/dashboard" exact element={<Home />} />}
      {user && <Route path="/home" exact element={<Dashboard />} />}
      {user && <Route path="/home/add-company" exact element={<AddCompany />} />}
      {user && <Route path="/home/edit-company/:admincode" exact element={<EditCompany />} />}
      {user && <Route path="/home/view-company" exact element={<ViewCompany />} />}
      {user && <Route path="/home/view-all-users/:id" exact element={<ShowUser />} />}
      {user && <Route path="/add-assesment/:id" exact element={<CompanyAssessment />} />}
      {user && <Route path="/home/all-assesments" exact element={<AllAssessments />} />} */}
     
      
    </Routes>
  );
};

const App = () => {
  const location = useLocation();

  // Check if the current route starts with "/dashboard"
  const isDashboardRoute = location.pathname.startsWith("/home");
  const isUserHomeRoute = location.pathname.startsWith("/userhome");
  const isLandingpageRoute = location.pathname.startsWith("/user-landingpage");
  const isUserLoginRoute = location.pathname.startsWith("/user-login");
  return (
    <>
      {/* Render Header only for non-dashboard routes */}
      {!isLandingpageRoute&&!isUserLoginRoute && <Header />}
      {(isLandingpageRoute|| isUserLoginRoute) && <UserHeader/>}
      <Routing />
    </>
  );
};

export default App;